<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear/Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_rh_conducir_licencia_tipo === null ? "Crear" : "Editar" }} Tipo de Licencia para Conducir
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text :loading="loadingSave" @click="saveDialogAddEdit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Tipo de Licencia</v-card-title>
        <v-card-text>
          ¿Está seguro de eliminar el tipo de licencia "{{ editedItem.nombre }}"?
          Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text :loading="loadingDelete" @click="saveDialogDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Toolbar -->
    <v-row>
      <v-col cols="12" class="d-flex align-center" style="gap:8px;">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Tipo de Licencia para Conducir
        </v-btn>
        <v-spacer></v-spacer>
        <v-progress-circular
          v-if="loadingOrder"
          indeterminate
          size="20"
          width="2"
          class="mr-2"
        />
        <span v-if="loadingOrder" class="text--disabled">Guardando orden…</span>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          item-key="id_rh_conducir_licencia_tipo"
          :items-per-page="-1"
          hide-default-footer
        >
          <!-- Cuerpo personalizado con draggable -->
          <template v-slot:body>
            <draggable
              v-model="itemsProxy"
              tag="tbody"
              handle=".drag-handle"
              :disabled="loadingOrder || loading"
              @end="onDragEnd"
            >
              <tr
                v-for="item in itemsProxy"
                :key="item.id_rh_conducir_licencia_tipo"
              >
                <td class="text-center" style="width:1px;">
                  <v-icon small class="drag-handle" :class="{'drag-disabled': loadingOrder || loading}">
                    mdi-drag
                  </v-icon>
                </td>
                <td class="text-center" style="width:90%;">
                  {{ item.nombre }}
                </td>
                <td class="text-center" style="width:9%;">
                  <v-icon small class="mr-2" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
                  <v-icon small class="mr-2" @click="openDialogDelete(item)">mdi-delete</v-icon>
                </td>
              </tr>
              <tr v-if="itemsProxy.length === 0">
                <td class="text--disabled pa-4" colspan="3">Sin tipos de licencia...</td>
              </tr>
            </draggable>
          </template>

          <!-- Mantengo el slot no-data por compatibilidad (no se usará con body custom) -->
          <template v-slot:no-data>
            <div class="text--disabled pa-4">Sin tipos de licencia...</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'
import draggable from 'vuedraggable'

export default {
  name: 'RHConducirLicenciaTipos',
  components: { VAlertDialog, draggable },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,
    loadingOrder: false,

    items: [],
    headers: [
      { text: '', value: 'drag', align: 'center', width: '1px', sortable: false },
      { text: 'Tipo de Licencia para Conducir', value: 'nombre', align: 'center', width: '90%', sortable: false },
      { text: 'Acciones', value: 'actions', align: 'center', width: '9%', sortable: false }
    ],

    editedItem: {
      id_rh_conducir_licencia_tipo: null,
      nombre: ''
    },
    defaultEditedItem: {
      id_rh_conducir_licencia_tipo: null,
      nombre: ''
    }
  }),
  computed: {
    // Proxy para que vuedraggable pueda reordenar la misma lista usada por v-data-table
    itemsProxy: {
      get () { return this.items },
      set (val) { this.items = val }
    }
  },
  mounted () {
    this.getItems()
  },
  methods: {
    // Cargar lista
    getItems () {
      this.loading = true
      axios
        .get('/RHCatalogos/ListarRHConducirLicenciaTipos')
        .then(res => { this.items = res.data })
        .catch(err => { console.error(err) })
        .finally(() => { this.loading = false })
    },

    // Diálogo crear/editar
    openDialogAddEdit (editItem = null) {
      this.editedItem = Object.assign({}, editItem ?? this.defaultEditedItem)
      this.dialogAddEdit = true
    },
    closeDialogAddEdit () {
      this.editedItem = Object.assign({}, this.defaultEditedItem)
      this.dialogAddEdit = false
    },

    // Guardar (crear/editar)
    saveDialogAddEdit () {
      if (!this.editedItem.nombre || this.editedItem.nombre.length > 256) {
        this.$refs.alert.setMessage('', 'Debe ingresar un Nombre entre 1 y 256 caracteres')
        this.$refs.alert.open()
        return
      }

      this.loadingSave = true
      const isCreate = this.editedItem.id_rh_conducir_licencia_tipo === null

      axios({
        method: isCreate ? 'POST' : 'PUT',
        url: isCreate
          ? '/RHCatalogos/CrearRHConducirLicenciaTipo'
          : `/RHCatalogos/EditarRHConducirLicenciaTipo/${this.editedItem.id_rh_conducir_licencia_tipo}`,
        data: { nombre: this.editedItem.nombre }
      })
        .then(() => {
          this.getItems()
          this.closeDialogAddEdit()
        })
        .catch(err => { console.error(err) })
        .finally(() => { this.loadingSave = false })
    },

    // Eliminar
    openDialogDelete (editItem) {
      this.editedItem = Object.assign({}, editItem)
      this.dialogDelete = true
    },
    closeDialogDelete () {
      this.editedItem = Object.assign({}, this.defaultEditedItem)
      this.dialogDelete = false
    },
    saveDialogDelete () {
      this.loadingDelete = true
      axios
        .delete(`/RHCatalogos/EliminarRHConducirLicenciaTipo/${this.editedItem.id_rh_conducir_licencia_tipo}`)
        .then(() => {
          this.closeDialogDelete()
          this.getItems()
        })
        .catch(err => { console.error(err) })
        .finally(() => { this.loadingDelete = false })
    },

    // Drag & Drop
    onDragEnd (evt) {
      // Sólo guarda si realmente cambió de posición
      if (evt && evt.oldIndex !== evt.newIndex) {
        this.saveOrder()
      }
    },

    saveOrder () {
      this.loadingOrder = true
      this.loading = true

      const payload = this.items.map((x, i) => ({
        id_rh_conducir_licencia_tipo: x.id_rh_conducir_licencia_tipo,
        posicion: i + 1
      }))

      axios.post('/RHCatalogos/OrdenarRHConducirLicenciaTipo', payload)
        .then(() => {
          // Opcional: podrías recargar para “confirmar” el orden definitivo del backend
          this.getItems()
        })
        .catch(err => {
          console.error(err)
          this.$refs.alert.setMessage('Error', 'No fue posible guardar el orden. Se recargará la lista.')
          this.$refs.alert.open()
          this.getItems()
        })
        .finally(() => {
          this.loadingOrder = false
        })
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: move;
}
.drag-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
